export { cn } from './cn';

/**
 * Get status color classes for booking statuses
 * @param {string} status - The booking status
 * @returns {string} Tailwind CSS classes for background and text colors
 */
export const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'bg-gray-100 text-black border border-gray-300';
    case 'confirmed':
      return 'bg-black text-white';
    case 'in_progress':
      return 'bg-gray-200 text-black border border-gray-400';
    case 'completed':
      return 'bg-black text-white';
    case 'cancelled':
      return 'bg-gray-300 text-black border border-gray-400';
    case 'no_show':
      return 'bg-gray-300 text-black border border-gray-400';
    case 'disputed':
      return 'bg-gray-200 text-black border border-gray-400';
    case 'refunded':
      return 'bg-gray-200 text-black border border-gray-400';
    default:
      return 'bg-gray-100 text-black border border-gray-300';
  }
};

/**
 * Format status text with proper capitalization
 * @param {string} status - The booking status
 * @returns {string} Formatted status text
 */
export const formatStatusText = (status) => {
  return status.replace('_', ' ').charAt(0).toUpperCase() + status.replace('_', ' ').slice(1).toLowerCase();
};

// Password validation utilities
export * from './passwordValidation';

// Date and time utilities
export * from './dateUtils';
